export default __webpack_public_path__ + "static/media/Main_Roadmap_Img_1_440px.ac15090c.png";